import * as yup from 'yup';

export const checks = [
	{
		re: /^.{8,}$/,
		label: 'At least 8 characters',
		message: 'Password must be at least 8 characters',
	},
	{
		re: /[A-Z]/,
		label: 'Includes uppercase letter',
		message: 'Password must contain at least one uppercase letter',
	},
	{ re: /[0-9]/, label: 'Includes number', message: 'Password must contain at least one number' },
];

export const getYupSchemaForPassword = (
	passwordInputName: string,
	reenterPasswordInputName: string
) => {
	let passwordInputValidation = yup.string().required('Password is required');
	checks.forEach((check) => {
		passwordInputValidation = passwordInputValidation.matches(check.re, check.message);
	});

	return yup.object({
		[passwordInputName]: passwordInputValidation,
		[reenterPasswordInputName]: yup
			.string()
			.required('Please re-enter your password.')
			.oneOf([yup.ref(passwordInputName)], 'The passwords must match.'),
	});
};
